import { render, staticRenderFns } from "./need.vue?vue&type=template&id=ddbc9fd8&scoped=true"
import script from "./need.vue?vue&type=script&lang=js"
export * from "./need.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbc9fd8",
  null
  
)

export default component.exports